import { lazy } from 'react';
import type { ComponentType, LazyExoticComponent } from 'react';

// named imports for React.lazy: https://github.com/facebook/react/issues/14603#issuecomment-726551598
export function lazyImport<TName extends string, TProps extends object = object>(
    factory: () => Promise<Record<TName, ComponentType<TProps>>>,
    name: TName,
): Record<TName, LazyExoticComponent<ComponentType<TProps>>> {
    return {
        [name]: lazy(() => factory().then((module) => ({ default: module[name] }))),
    } as Record<TName, LazyExoticComponent<ComponentType<TProps>>>
}
